/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const SupportLink = styled.a`
  color: inherit;
  font-weight: bold;

  &&:hover,
  &&:focus {
    color: inherit;
  }
`;
